import React from 'react';
import PropTypes from 'prop-types';
import YouTubePlayer from 'react-youtube';
import LazyLoad from 'react-lazyload';

import cx from 'classnames';
import { optimiseImage } from 'src/common/utils/prismic-image';
import './YouTube.scss';

const getPosterImage = props => {
  if (props.imagePath) {
    return optimiseImage(props.imagePath);
  }
  return `https://img.youtube.com/vi/${props.videoId}/maxresdefault.jpg`;
};

const opts = {
  width: '100%',
  height: '100%',
  playerVars: {
    disablekb: 1,
    rel: 0,
    fs: 0,
    showinfo: 0,
    autoplay: 0,
    playsinline: 1,
    start: 0
  }
};


const YouTube = props => (
  <div className={cx(
    'youtube-wrapper',
    { 'youtube-wrapper-full': props.isFullScreen }
  )}>
    {props.isPlaying ?
      <YouTubePlayer
        videoId={props.videoId}
        id={props.videoId}
        opts={opts}
        onReady={props.handleReady}
        onEnd={props.handleEnd}
        onStateChange={props.handleStateChange}
      /> :
      <div className="youtube-placeholder-wrapper">
        <LazyLoad>
          <img src={getPosterImage(props)} alt="" className="youtube-placeholder"/>
        </LazyLoad>
        <div className="youtube-play-icon" onClick={props.handleClick}>
          <i className="ss-icon ss-play"/>
        </div>
      </div>
    }
  </div>
);

YouTube.propTypes = {
  videoId: PropTypes.string.isRequired,
  imagePath: PropTypes.string,
  isPlaying: PropTypes.bool.isRequired,
  handleReady: PropTypes.func.isRequired,
  handleEnd: PropTypes.func.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool

};

export default YouTube;



// WEBPACK FOOTER //
// ./src/client/js/view/components/YouTube/YouTube.js